import { Link } from "gatsby";
import { ExternalLink } from "../../../../src/components/ExternalLink.js";
import * as React from 'react';
export default {
  Link,
  ExternalLink,
  React
};